import { useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';

/**
 * Move focus to the page's <h1> after every route change so screen-reader
 * users get context. The h1 must be present; if a route lacks one, focus
 * silently falls back to the body (status quo).
 */
export function useFocusOnRouteChange() {
  const loc = useLocation();
  useEffect(() => {
    const h1 = document.querySelector('h1');
    if (h1 instanceof HTMLElement) {
      h1.setAttribute('tabindex', '-1');
      h1.focus({ preventScroll: false });
    }
  }, [loc.pathname]);
}
